module.exports = __webpack_public_path__ + "15acb407ee583815161ea6da5f23ab88.png";